<template>
    <div>
        <DetaliedShipmentsOrderHistoryDialog
            :detalied-shipments-order-history="detaliedShipmentsOrderHistory"
            :shipping-order-data="shippingOrderData"
            :is-open="detaliedShipmentsOrderHistoryDialog"
            @on-close="closeDetaliedShipmentsOrderHistoryDialog"
        />
        <v-dialog
            :value="isOpen"
            max-width="900px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Metryka dokumentu
                    </h1>
                </v-card-title>

                <v-card-text>
                    <v-data-table
                        :headers="shippingOrderHistoryHeaders"
                        :items="shippingOrder.changesHistory"
                        :items-per-page="5"
                        :page.sync="currentPaginationPage"
                        :footer-props="{
                            itemsPerPageText: 'Zmian na stronie',
                            showFirstLastPage: false
                        }"
                        :mobile-breakpoint="0"
                        name="shippingOrderHistoryData"
                    >
                        <template #item.changedBy="{item}">
                            <template v-if="item.changedBy.firstName && item.changedBy.lastName">
                                {{ item.changedBy.firstName }} {{ item.changedBy.lastName }}
                            </template>
                            <template v-else>
                                {{ item.changedBy.username }}
                            </template>
                        </template>
                        <template #item.changedAt="{item}">
                            {{ formatDate(item.changedAt) }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Otwórz szczegółową historię zmian"
                                            v-on="on"
                                            @click="showDetiledShipmentsOrderHistory(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Otwórz</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Zamknij"
                        @click="onClose"
                    >
                        Zamknij
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import DetaliedShipmentsOrderHistoryDialog from './DetaliedShipmentsOrderHistoryDialog'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'ShipmentsOrderHistoryDialog',
    components: {
        DetaliedShipmentsOrderHistoryDialog
    },
    mixins: [
        dateFormatter,
        tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        shippingOrderData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            shippingOrder: {
                changesHistory: []
            },
            detaliedShipmentsOrderHistory: [],
            detaliedShipmentsOrderHistoryDialog: false,
            currentPaginationPage: null,
            shippingOrderHistoryHeaders: [
                {
                    text: 'Zmieniający',
                    sortable: false,
                    value: 'changedBy'
                },
                {
                    text: 'Data utworzenia',
                    align: 'center',
                    sortable: false,
                    value: 'changedAt'
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 120
                }
            ]
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                return this.shippingOrder = JSON.parse(JSON.stringify(this.shippingOrderData))
            } else {
                this.shippingOrder = {
                    changesHistory: []
                }
            }
        }
    },
    methods: {
        showDetiledShipmentsOrderHistory(item) {
            this.detaliedShipmentsOrderHistory = item.formattedDiff
            this.detaliedShipmentsOrderHistoryDialog = true
            this.onClose()
        },
        closeDetaliedShipmentsOrderHistoryDialog(shippingOrder) {
            this.detaliedShipmentsOrderHistoryDialog = false
            this.$emit('show-shipping-order-history-dialog', shippingOrder)
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>